import { createTheme } from "@mui/material/styles";

/**
 * MUI's half of the palette.
 *
 * The colours themselves are custom properties in src/styles/palette.css. MUI's
 * theme is a JS object and Tailwind's utilities are build-time CSS, so a custom
 * property is the one shape both can read: this file only points MUI at the
 * properties, and the media query in palette.css is what changes them.
 *
 * `colorSchemeSelector: "media"` is what makes the site follow the OS. There is
 * no toggle and no stored preference, so no script has to run before paint, and
 * no second set of values is needed for dark.
 *
 * `nativeColor` makes MUI derive its hover and overlay tints with color-mix()
 * instead of from a palette channel. A channel is an rgb triple it parses out of
 * the value at build time, which a `var()` does not have.
 */
const token = (name: string) => `var(${name})`;

const palette = {
  background: { default: token("--lm-surface"), paper: token("--lm-paper") },
  text: { primary: token("--lm-ink"), secondary: token("--lm-ink-muted") },
  divider: token("--lm-border"),
};

const theme = createTheme({
  cssVariables: { colorSchemeSelector: "media", nativeColor: true },
  colorSchemes: { light: { palette }, dark: { palette } },
});

export default theme;
